import React from 'react';
import { Check, Star, TrendingUp, TrendingDown } from 'lucide-react';
import Container_5 from 'assets/images/Container-5.png';

const WhyChooseUsSection = () => {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Columna izquierda - Imagen con overlay de gráfico */}
          <div className="relative">
            {/* Imagen principal */}
            <img src={Container_5} alt="Why Choose Us" />
          </div>

          {/* Columna derecha - Contenido de texto */}
          <div className="space-y-8">
            {/* Header */}
            <div className="space-y-4">
              <h2 className="text-red-500 font-semibold text-sm uppercase tracking-wider">
                WHY CHOOSE US
              </h2>
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-800">
                Business Solutions
              </h3>
            </div>

            {/* Lista de soluciones */}
            <div className="space-y-6">
              {/* Solución 1 */}
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2">Target & Market Research</h4>
                  <p className="text-gray-600">
                    Azucarai collects and analyzes data to target audience and strategies.
                  </p>
                </div>
              </div>

              {/* Solución 2 */}
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2">Successful Digital Marketing Strategies</h4>
                  <p className="text-gray-600">
                    We deliver measurable and satisfactory results for our clients.
                  </p>
                </div>
              </div>

              {/* Solución 3 */}
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2">Professional Optimization</h4>
                  <p className="text-gray-600">
                    Our Team improves digital marketing strategies and campaigns to achieve optimal results.
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial */}
            <div className="bg-gray-50 rounded-lg p-6 relative">
              {/* Comillas de apertura */}
              <div className="absolute top-2 right-4">
                <span className="text-red-500 text-4xl font-bold">"</span>
              </div>
              
              {/* Contenido del testimonial */}
              <div className="space-y-4">
                <div className="flex items-center space-x-2">
                  <h5 className="font-bold text-gray-800">Rebecca Bettle</h5>
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                    ))}
                  </div>
                </div>
                
                <p className="text-gray-600 leading-relaxed">
                  "We are a small business and Azucarai has been instrumental in getting our name out there. They went the extra mile helping us to connect with Google and promote our business in the most effective way. Worth every penny!"
                </p>
              </div>
              
              {/* Comillas de cierre */}
              <div className="absolute bottom-2 right-4">
                <span className="text-red-500 text-4xl font-bold">"</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsSection;





